import * as constants from '../constants/constants';

const defaultStore = {
  tags: [],
  allEatingsTags: [],
  allDishTypeTags: [],
  allCategoryIngridients: [],
  allVideoTags: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: action.data,
      };
    case constants.SET_TAGS_BY_CATEGORIES:
      return {
        ...state,
        allEatingsTags: action.payload.allEatingsTags,
        allDishTypeTags: action.payload.allDishTypeTags,
        allCategoryIngridients: action.payload.allCategoryIngridients,
        allVideoTags: action.payload.allVideoTags,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/getTags.js